module.exports = __webpack_public_path__ + "static/media/favicon.5ef72405.ico";